import { Table } from "@mui/material";
import { type Ref, forwardRef } from "react";
import type { TableProps as VirtuosoTableProps } from "react-virtuoso";
import { useTableVirtualizedContext } from "./context";

export const VirtuosoTable = forwardRef(function VirtuosoTable(
  { children, ...props }: VirtuosoTableProps,
  ref: Ref<HTMLTableElement>
) {
  const { slotProps } = useTableVirtualizedContext();

  return (
    <Table {...props} size="small" ref={ref} {...slotProps?.table}>
      {children}
    </Table>
  );
});
